// Login.js
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import "./Login.css";
import "@assets/Feelmehome.css";
import facebookIcon from "@assets/img/facebook.png";
import facebookIconWebp from "@assets/img/facebook.webp";
import { connect } from "react-redux";
import { setUser, userSetNew } from "../actions/user";
import { onMessage, emitMessage } from "../actions/socket";
import {
  setHome,
  homeSetSlots,
  homeSetAds,
  homeSetNotifications,
} from "../actions/home";
import { setConversationPreview } from "../actions/conversation";
import { fetcher } from "../components/utility";
import { setIdGA } from "../components/TrackerGA";
import {
  facebookLogin,
  isLoggedIn,
  initializeSocialLogin,
} from "../components/socialLoginUtility";
import { saveAccessToken } from "../components/authPersistence";
import {
  TextField,
  FormControlLabel,
  Checkbox,
  adaptV4Theme,
} from "@mui/material";
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";
import PlatformAwareGoogleButton from "../components/PlatformAwareGoogleButton";
import Button from "../components/Button";
import Loader from "../components/Loader";
import { t, Trans } from "@lingui/macro";
import * as Sentry from "@sentry/react";

const theme = createTheme(
  adaptV4Theme({
    palette: {
      primary: {
        // Purple and green play nicely together.
        main: "#ff7417",
      },
    },
  })
);

window.GOOGLE_BUTTON_ID = "google-sign-in-button";
window.FACEBOOK_LOGGED = false;

const mapStateToProps = (state) => {
  return {
    logged: state.User.logged,
    newUser: state.User.new,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onMessage: (event, handle) => dispatch(onMessage(event, handle)),
    emitMessage: (event, handle) => dispatch(emitMessage(event, handle)),
    setUser: (user) => dispatch(setUser(user)),
    userSetNew: (bool) => dispatch(userSetNew(bool)),
    setHome: (home) => dispatch(setHome(home)),
    homeSetSlots: (slots) => dispatch(homeSetSlots(slots)),
    homeSetAds: (advertises) => dispatch(homeSetAds(advertises)),
    homeSetNotifications: (notifications) =>
      dispatch(homeSetNotifications(notifications)),
    setConversationPreview: (previews) =>
      dispatch(setConversationPreview(previews)),
  };
};

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      logged: false,
      mail: "",
      password: "",
      remember: true,
      isOpen: false,
      loading: false,
      success: false,
      disabled: false,
      needsVerification: false,
    };
  }

  async componentDidMount() {
    // Initialize social login when component mounts
    await initializeSocialLogin();

    // Check if user is already logged in via social providers
    this.checkAutoLogin();
  }

  checkAutoLogin = async () => {
    try {
      const facebookLoggedIn = await isLoggedIn("facebook");
      const googleLoggedIn = await isLoggedIn("google");

      if (facebookLoggedIn) {
        await this.handleFacebookLogin();
      } else if (googleLoggedIn) {
        await this.handleGoogleLogin();
      }
    } catch (error) {
      console.error("Auto login check error:", error);
    }
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.logged !== this.props.logged ||
      prevProps.newUser !== this.props.newUser
    ) {
      if (this.props.logged === true) {
        document.getElementById("closing_modal").click();
      }
    }
  }

  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.logIn();
    }
  };

  logIn = () => {
    this.setState({ disabled: true });
    const { mail, password, remember } = this.state;
    const loginCredentials = { mail, password, remember };

    fetcher({
      path: "/api/logIn",
      credentials: true,
      redirect: "follow",
      method: "POST",
      body: loginCredentials,
    })
      .then((res) => {
        if (!res.success) {
          if (res.needsVerification) {
            this.setState({ needsVerification: true, disabled: false });
          } else {
            this.setState({ logged: null, disabled: false, needsVerification: false });
          }
        } else {
          res.user.logged = true;
          this.setState({ logged: true });
          setIdGA(res.user._id);

          // Save auth data for persistent login with JWT token
          saveAccessToken(res.accessToken);

          res.user.tenants.forEach((tenant, index) => {
            if (tenant.user_id) {
              let user_tenant = res.user_tenants.find(
                (x) => x._id == tenant.user_id
              );
              if (user_tenant) {
                let pickedUser = {};
                pickedUser.value = user_tenant._id;
                pickedUser.image = user_tenant.profile_image;
                pickedUser.image_webp = user_tenant.profile_image_webp;
                pickedUser.location = user_tenant.location;
                pickedUser.age = user_tenant.age;
                pickedUser.type = user_tenant.type;
                pickedUser.label = user_tenant.name + " " + user_tenant.surname;
                res.user.tenants[index].pickedUser = pickedUser;
                res.user.tenants[index].image = user_tenant.profile_image;
                res.user.tenants[index].image_webp =
                  user_tenant.profile_image_webp;
              }
            }
          });
          this.props.setUser(res.user);
          if (res.notifications != null) {
            this.props.homeSetNotifications(res.notifications);
          }
          if (res.home != null) {
            res.home.tenants.forEach((tenant, i_t) => {
              if (tenant.user_id) {
                let home_tenant = res.home_tenants.find(
                  (x) => x._id == tenant.user_id
                );
                if (home_tenant) {
                  let pickedUser = {};
                  pickedUser.value = home_tenant._id;
                  pickedUser.image = home_tenant.profile_image;
                  pickedUser.image_webp = home_tenant.profile_image_webp;
                  pickedUser.location = home_tenant.location;
                  pickedUser.age = home_tenant.age;
                  pickedUser.type = home_tenant.type;
                  pickedUser.label =
                    home_tenant.name + " " + home_tenant.surname;
                  res.home.tenants[i_t].pickedUser = pickedUser;
                  res.home.tenants[i_t].image = home_tenant.profile_image;
                  res.home.tenants[i_t].image_webp =
                    home_tenant.profile_image_webp;
                }
              }
            });
            if (res.ads != null) {
              res.home.advertises = res.ads;
            }
            this.props.setHome(res.home);

            if (res.slotArray != null) {
              this.props.homeSetSlots(res.slotArray);
            }
          }
          if (res.notifications != null) {
            this.props.homeSetNotifications(res.notifications);
          }
          if (res.conversations != null) {
            this.props.setConversationPreview(res.conversations);
          }
          if (res.home != null) {
            this.props.emitMessage("login_home", res.home._id);
            this.props.emitMessage("login_user", res.user._id);
          } else this.props.emitMessage("login_user", res.user._id);
        }
      })
      .catch((e) => {
        Sentry.captureException(e);
        this.setState({ disabled: false });
      });
  };

  handleFacebookLogin = async () => {
    if (window.FACEBOOK_LOGGED) return;

    window.FACEBOOK_LOGGED = true;
    try {
      const result = await facebookLogin();
      if (result.success) {
        // Login successful - user state is already updated in the utility
        this.setState({ logged: true });
      } else {
        console.error("Facebook login failed:", result.error);
      }
    } catch (error) {
      console.error("Facebook login error:", error);
      Sentry.captureException(error);
    } finally {
      window.FACEBOOK_LOGGED = false;
    }
  };

  checkMailState = (event) => {
    this.setState({ mail: event.target.value });
  };

  checkPasswordState = (event) => {
    this.setState({ password: event.target.value });
  };

  checkrememberState = (event) => {
    this.setState({
      remember: event.currentTarget.checked ? true : false,
    });
  };

  render() {
    const { mail, remember, logged, password, needsVerification } = this.state;
    const { inSignup } = this.props;
    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className={"col " + (!inSignup ? "" : "nopadding")}>
            <div className="panel panel-default">
              {!inSignup && (
                <div className="panel-heading">
                  <div
                    className="thipi-text-h2 text-center pt-2 pb-2"
                    style={{ lineHeight: 1 }}
                  >
                    {logged != null && this.props.create
                      ? t`Accedi o registrati per continuare`
                      : t`Benvenuto su Thipibo`}
                  </div>
                </div>
              )}
              <div className="panel-body">
                <button
                  id="facebookButton"
                  className="btn facebook-btn btn-block"
                  type="button"
                  onClick={this.handleFacebookLogin}
                >
                  <picture>
                    <source type="image/webp" srcSet={facebookIconWebp} />
                    <source type="image/png" srcSet={facebookIcon} />
                    {/*eslint-disable-next-line lingui/no-unlocalized-strings*/}
                    <img src={facebookIcon} alt="facebook Logo" />
                  </picture>
                  <span>
                    <Trans>Continua con Facebook</Trans>
                  </span>
                </button>
                <center className="py-2">
                  <PlatformAwareGoogleButton theme="light" />
                </center>
                <center>
                  <div className="login-or">
                    <Trans>oppure</Trans>
                  </div>
                </center>
                {!inSignup && (
                  <form acceptCharset="UTF-8">
                    <div>
                      <TextField
                        variant="outlined"
                        size="small"
                        name="youremail"
                        label={t`E-mail`}
                        type="email"
                        autoComplete="username"
                        onChange={this.checkMailState}
                        onKeyPress={this.handleKeyPress}
                        value={mail}
                        error={logged === null}
                        fullWidth
                        required
                        autoFocus
                      />
                    </div>
                    <div className="mt-2">
                      <TextField
                        variant="outlined"
                        size="small"
                        name="password"
                        label={t`Password`}
                        type="password"
                        autoComplete="current-password"
                        onChange={this.checkPasswordState}
                        onKeyPress={this.handleKeyPress}
                        value={password}
                        error={logged === null}
                        helperText={
                          logged === null ? t`mail o password errati` : null
                        }
                        fullWidth
                        required
                      />
                    </div>
                    <div className="mt-2">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={remember}
                            onChange={this.checkrememberState}
                            name="remember"
                            color="primary"
                          />
                        }
                        label={t`Ricordami`}
                      />
                    </div>

                    {needsVerification && (
                      <div className="text-center mb-2" style={{ color: "orange" }}>
                        <Trans>
                          Conferma la tua email prima di accedere. Controlla la
                          tua casella di posta e clicca sul link di verifica.
                        </Trans>
                      </div>
                    )}
                    <Button
                      id="modalLogin"
                      className="btn-block"
                      type="button"
                      disabled={this.state.disabled}
                      ref={(btnLogin) => {
                        this.btnLogin = btnLogin;
                      }}
                      onClick={() => {
                        this.logIn();
                      }}
                    >
                      {this.state.disabled ? <Loader /> : t`Accedi`}
                    </Button>
                    <div className="text-center pb-3">
                      {this.props.children}
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Login);
